import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LoaderService } from "../../../shared/services/loader/loader.service";
import { finalize } from "rxjs/operators";

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private totalRequest = 0;

  constructor(private loaderService: LoaderService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    this.totalRequest++;
    this.loaderService.setLoading(true);

    return next.handle(req).pipe(
      finalize(() => {
        this.totalRequest--;
        if (this.totalRequest == 0) {
          this.loaderService.setLoading(false);
        }
      })
    );
  }
}
